import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnInit } from '@angular/core';
import { combineLatest } from 'rxjs';

import { PageMetaService } from '@spartacus/core';

import { SdMultimediaComponent } from '@seb/web-design-system/multimedia';
import { IMedia, SdSpyTargetDirective } from '@seb/web-design-system/core';

import { MultimediaComponentInterface, MultimediaModuleInterface } from '../../../models';
import { AbstractModuleComponent } from '../abstract-module.component';
import { WrapperComponent } from '../../../components/static/core';
import { ImageService } from '../../../services';

@Component({
  selector: 'wc-multimedia-module',
  templateUrl: './multimedia-module.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    WrapperComponent,
    SdMultimediaComponent,
    SdSpyTargetDirective
  ]
})
export class MultimediaModuleComponent extends AbstractModuleComponent<MultimediaModuleInterface> implements OnInit {
  @Input() class = '';

  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, 'wc-component is-cms'].filter(Boolean).join(' ');
  }

  medias: IMedia[];
  context = 'Multimedia';
  autoplayVideo: boolean;
  loopVideo: boolean;
  mutedVideo: boolean;
  noStyle: boolean;

  constructor(
    private imageService: ImageService,
    private cdRef: ChangeDetectorRef,
    private pageMetaService: PageMetaService
  ) {
    super();
  }

  override mandatoryComponentFunction = (cmp: MultimediaComponentInterface): boolean => {
    return !!cmp.media;
  };

  ngOnInit(): void {
    this.subscriptions.add(
      combineLatest([this.pageMetaService.getMeta(), this.module$]).subscribe(([meta, module]) => {
        this.context = meta.title + ' ' + (this.wrapper?.wrapperHeading?.headline || '');
        this.medias = module.componentsObjects
          .slice(0, 5)
          .map((cmp: MultimediaComponentInterface) => this.imageService.normalizeMedia(cmp.media, cmp.videoFallback));
        this.autoplayVideo = module.autoplay === 'true';
        this.loopVideo = module.loop === 'true';
        this.mutedVideo = module.muted === 'true';
        this.noStyle = module.noStyle === 'true';
        this.setLoaded();
        this.cdRef.markForCheck();
      })
    );
  }
}
